import { render, staticRenderFns } from "./CollectionEfforts.vue?vue&type=template&id=796a5086&"
import script from "./CollectionEfforts.vue?vue&type=script&lang=js&"
export * from "./CollectionEfforts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports